import {
  CDN_ASSETS_BASE_URL,
  ROUTES,
} from '@frodo/lib/utils/common/constants';

export const getPublicImagePath = (path: string) =>
  `${CDN_ASSETS_BASE_URL}/images/${path}`;

export const getPublicSvgPath = (path: string) =>
  `${CDN_ASSETS_BASE_URL}/svgs/${path}`;

export const getCloudinaryUrl = (
  cloudinaryBaseUrl: string,
  imageUrl: string,
  config?: string,
) => {
  const defaultConfig = 'f_auto,q_auto,fl_progressive,w_auto,dpr_auto';

  return `${cloudinaryBaseUrl}${config ?? defaultConfig}/${imageUrl}`;
};

export const attachQueryParams = (
  url: string,
  params: Record<string, string>,
): string => {
  if (!url || !params || Object.keys(params).length === 0) {
    return url;
  }

  const [baseUrl, existingQuery] = url.split('?');
  const searchParams = new URLSearchParams(existingQuery);

  Object.entries(params).forEach(([key, value]) => {
    if (key && value) {
      searchParams.set(key, value);
    }
  });

  const queryString = searchParams.toString();

  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

export function getCategoryURL(categoryCode: string, categoryName: string) {
  return `${ROUTES.category}/${categoryName}/c-${categoryCode}`;
}
